import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { initSentry } from './lib/sentry';
import { initTheme } from './lib/theme';
import { installAdminZodMessages } from './lib/zod-messages';
import './index.css';

// Birinchi qator: bundan keyingi har qanday yiqilish ko'rinadigan bo'ladi.
initSentry();

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

initTheme();
// Forma xatolari zod dan keladi, sxemalar esa shartnoma paketida — xabarlar shu yerda
// o'zbekchaga o'giriladi (`lib/zod-messages.ts` izohiga qarang).
installAdminZodMessages();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
